var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:{
    primary: _vm.color === 'primary',
    destructive: _vm.color === 'destructive',
    warning: _vm.color === 'warning',
    outline: _vm.outline,
    plain: _vm.plain,
    small: _vm.small,
    hover: _vm.hover,
    normal: _vm.normal,
    'no-focus': _vm.noFocus,
  },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }